<template>
  <div
    :class="{edit: isEdit, 'order-basket-item--not-available': !movingAvailabilityByItem[item.id]}"
    class="order-basket-item"
    @mouseenter="onMouseenter"
    @mouseleave="onMouseleave">
    <a
      :href="item.url"
      class="order-basket-item_col-name">
      {{ item.name }}
      <template v-if="!movingAvailabilityByItem[item.id]">
        <br> НЕДОСТУПНО
      </template>
    </a>
    <div class="order-basket-item_col-price">
      <div class="price">
        {{ getPriceLocale }}
      </div>
      <div
        v-if="isEdit"
        class="count-input">
        <input
          :value="item.count"
          type="number"
          @input="onChangeCount">
      </div>
      <div
        v-else
        class="count-string">
        {{ item.count }}
      </div>
    </div>
  </div>
</template>

<script>
  import localPrice from '../../utils/localPrice'
  import {mapActions, mapMutations, mapState} from 'vuex'

  export default {
    name: 'BasketItem',
    props: {
      item: {
        type: Object,
        default: () => {
        }
      }
    },
    data: function () {
      return {
        isEdit: false,
        historyCount: 1
      }
    },
    computed: {
      getPriceLocale: function () {
        return localPrice(this.item.price)
      },
      ...mapState('order', [
        'movingAvailabilityByItem'
      ])
    },
    methods: {
      ...mapMutations('order', [
        'setBasketItemCountById'
      ]),
      ...mapActions('order', [
        'setBasketItemCount'
      ]),
      onMouseenter: function () {
        this.isEdit = true
        this.historyCount = this.item.count
      },
      onMouseleave: function () {
        this.isEdit = false
        if (this.item.count !== this.historyCount) {
          this.setBasketItemCount({
            id: this.item.id,
            count: this.item.count
          })
        }
      },
      onChangeCount: function (e) {
        this.setBasketItemCountById({
          id: this.item.id,
          value: e.target.value
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/BasketItem.vue